import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { IFullState } from '../../types/All.type';

const RequireAuth = () => {
  const userState = useSelector((state: IFullState) => state.genesisUserRolePermission);
  const location = useLocation();
  if (userState.isAuthorized || userState.isEosUser) {
    return <Outlet />;
  }
  sessionStorage.setItem('redirectPath', `${location.pathname}${location.search}${location.hash}`);

  return <Navigate to='/' replace />;
};

export default RequireAuth;
